<script setup lang="ts">
import type { Article } from "~/types/article"
import { TEMPLATES } from "~/utilities/articles"

const { subjectPage = false, data } = defineProps<{
  firstAudioArticleUrl?: string
  subjectPage?: boolean
  data: Article
}>()

const productContent = useProductContentStore()
const { contributors } = useProductContributors()

const isFirstArticle = computed(() => productContent.articles[0]?.id === productContent.activeArticle?.id)

const shouldDisplayContributors = computed(() => {
  return contributors.value &&
    contributors.value?.length > 0 &&
    isFirstArticle.value &&
    data.template !== TEMPLATES.QUIZ &&
    data.template !== TEMPLATES.VIDEO
})
</script>

<template>
  <header class="flex flex-col gap-4">
    <slot name="contentTag" />
    <USubjectShortTitle
      :subject-page="subjectPage"
      :parent-location-id="data.parentLocationId ?? undefined"
    />

    <div class="flex flex-col gap-4 md:gap-8">
      <UArticleTitle :article="data" />

      <UProductContributors v-if="shouldDisplayContributors" />

      <UAudioPlayerButton :first-audio-article-url="firstAudioArticleUrl" />
    </div>
  </header>
</template>
